var safeString = {
  exports: {}
};

export { safeString as s };
